<template>
    <div :class="['loading', color, size]">
        <div class="spinner"></div>
    </div>
</template>

<script>
    export default {
        name: 'Loading',

        props: {
            color: {
                type: String
            },

            size: {
                type: String
            }
        }
    };
</script>

<style scoped lang="scss">
    @import 'source/stylesheets/sass/abstract/bpo-variables.scss';

    .loading {
        display: inline-flex;
        align-items: center;
        justify-content: center;

        &.small > .spinner {
            width: 20px;
            height: 20px;

            &:after,
            &:before {
                border-width: 4px;
                width: 20px;
                height: 20px;
            }
        }

        &.medium > .spinner {
            width: 44px;
            height: 44px;

            &:after,
            &:before {
                border-width: 6px;
                width: 44px;
                height: 44px;
            }
        }

        &.large > .spinner {
            width: 52px;
            height: 52px;

            &:after,
            &:before {
                border-width: 7px;
                width: 52px;
                height: 52px;
            }
        }

        &.larger > .spinner {
            width: 72px;
            height: 72px;

            &:after,
            &:before {
                border-width: 8px;
                width: 72px;
                height: 72px;
            }
        }

        &.white > .spinner {
            &:before {
                border-color: rgba($white, .3);
            }

            &:after {
                border-top-color: $white;
            }
        }

        &.black > .spinner {
            &:before {
                border-color: $quaternary;
            }

            &:after {
                border-top-color: $tertiary;
            }
        }
    }

    .spinner {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        position: relative;
        display: inline-block;

        &:after,
        &:before {
            content: '';
            display: block;
            width: 32px;
            height: 32px;
            border-radius: 50%;
        }

        &:before {
            position: absolute;
            top: 0;
            left: 0;
            border: 5px solid rgba($accent, .2);
        }

        &:after {
            position: absolute;
            top: 0;
            left: 0;
            border: 5px solid transparent;
            border-top-color: $accent;
            animation: spin 1s ease-in-out infinite;
        }
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }
</style>
